import { ColumnDef, CustomTable } from "../../../../common/table";
import TextField from "../../../../common/text-field/TextField";
import Button from "../../../../common/button/Button";
import {
  payValueType,
  payValueTypeOptions,
} from "../../../../../constants/constants";
import { EarningFormData, IEarningDetails } from ".";
import SelectField from "../../../../common/select/SelectField";

interface Props {
  earnings: IEarningDetails[];
  errors: Partial<Record<keyof EarningFormData, string>>;

  handleEarningChange: (
    index: number,
    field: keyof IEarningDetails,
    value: string | number,
  ) => void;
  addMore: () => void;
  handleRemoveEarning: (index: number) => void;
}

const EarningDetails = ({
  earnings,
  errors,
  handleEarningChange,
  addMore,
  handleRemoveEarning,
}: Props) => {
  const columns: ColumnDef<IEarningDetails>[] = [
    {
      header: "Earning Name",
      className: "pr-2 pl-2",
      render: (earning, index) => (
        <TextField
          name="name"
          value={earning.name}
          onChange={(e) => handleEarningChange(index, "name", e.target.value)}
          placeholder="Earning Name"
        />
      ),
    },
    {
      header: "Value",
      className: "w-[120px] sm:w-[150px] pr-2 pl-2",
      render: (earning, index) => (
        <TextField
          name="value"
          type="number"
          value={earning.value}
          onChange={(e) => handleEarningChange(index, "value", e.target.value)}
          placeholder="Value"
          className="w-[80%]"
        />
      ),
    },

    {
      header: `${payValueType.PERCENTAGE} / ${payValueType.FIXED}`,
      className: "pr-2 pl-2",
      render: (earning, index) => (
        <SelectField
          value={
            earning.valueType
              ? (payValueTypeOptions.find(
                  (ele) => ele.value === earning.valueType,
                ) ?? "")
              : ""
          }
          name={"valueType"}
          options={payValueTypeOptions}
          onChange={(option) =>
            handleEarningChange(index, "valueType", option.value)
          }
          placeholder="Value Type"
        />
      ),
    },
    {
      header: "Action",
      className: "pr-0 pl-0",
      render: (_, index) => {
        return (
          <Button
            onClick={(e) => {
              e.preventDefault(); 
              handleRemoveEarning(index)}}
            variant="danger"
            size="sm"
            leftIcon={<i className="fa-solid text-secondary fa-xmark"></i>}
          />
        );
      },
    },
  ];
  return (
    <>
      <div className="flex items-center justify-between border-b border-secondary pb-3 mb-2">
        <h2 className="text-md  font-medium">Earning Details</h2>

        <Button
          type="button"
          name="Add More"
          size="sm"
          onClick={addMore}
          leftIcon={<i className="fa-solid fa-plus"></i>}
        />
      </div>
      <CustomTable columns={columns} data={earnings} />
      {errors.details && (
        <p className="mt-1 text-xs text-error">{errors.details}</p>
      )}
    </>
  );
};

export default EarningDetails;
